<template>
    <div class="home">
      <ConfigComponents msg="配置页面"/>
    </div>
  </template>

  <script lang="ts">
  import { defineComponent } from 'vue'
  import ConfigComponents from '@/components/ConfigComponents.vue' // @ is an alias to /src

  export default defineComponent({
    name: 'configPage',
    components: {
      ConfigComponents
    }
  })
  </script>
